import { CheckCircle } from "lucide-react"
import type { ComponentProps } from "react"
import { cn } from "@/utilities"

interface SuccessHeroProps extends ComponentProps<"div"> {}

export function SuccessHero({ className, ...props }: SuccessHeroProps) {
  return (
    <div
      aria-live='polite'
      className={cn("flex flex-col items-center gap-4 text-center", className)}
      {...props}
    >
      <div className='flex size-16 items-center justify-center rounded-full bg-green-50'>
        <CheckCircle aria-hidden='true' className='size-8 text-green-600' />
      </div>
      <div className='space-y-2'>
        <h1 className='font-semibold text-3xl text-foreground tracking-tight sm:text-4xl'>
          Pedido realizado com sucesso!
        </h1>
        <p className='text-base text-muted-foreground sm:text-lg'>
          Obrigado pela sua compra. Você receberá um e-mail de confirmação em
          breve.
        </p>
      </div>
    </div>
  )
}
